// Function to generate variations of words
const generateVariations = (word) => {
  const variations = new Set([word]);
  
  // Common letter to number/symbol mappings
  const substitutions = {
    'a': ['4', '@'],
    'e': ['3'],
    'i': ['1', '!'],
    'o': ['0'],
    's': ['5', '$'],
    't': ['7'],
    'g': ['9'],
    'l': ['1'],
  };

  // Create variations with letter substitutions
  const words = [word];
  words.forEach(currentWord => {
    Object.entries(substitutions).forEach(([letter, replacements]) => {
      if (currentWord.includes(letter)) {
        replacements.forEach(replacement => {
          variations.add(currentWord.replace(new RegExp(letter, 'g'), replacement));
        });
      }
    });
  });

  // Add common prefixes and suffixes
  const prefixes = ['', '_', 'x', 'the', 'real', 'its', 'im'];
  const suffixes = ['', '_', 'x', '123', '321', '69', '420', 'xx', 'official'];

  prefixes.forEach(prefix => {
    suffixes.forEach(suffix => {
      variations.add(`${prefix}${word}${suffix}`);
    });
  });

  return [...variations];
};

// Base list of illegal usernames
const baseIllegalUsernames = [
 // Nazi/Fascist Terms & Leaders
 "hitler", "adolf", "adolfhitler", "h1tler", "nazi", "n4zi", "nsdap",
 "holocaust", "fuehrer", "führer", "reich", "thirdreich", "3rdreich",
 "heil", "heilhitler", "ss", "schutzstaffel", "gestapo", "swastika", 
 "aryan", "aryannation", "stormfront", "white_power", "whitepride",
 "goebbels", "himmler", "mengele", "eichmann", "bormann", "heydrich",
 "speer", "goering", "göring", "eva_braun", "blitzkrieg", "luftwaffe",
 "wehrmacht", "waffen", "totenkopf", "nuremberg", "lebensraum",
 "kristallnacht", "auschwitz", "dachau", "treblinka", "bergen",
 "buchenwald", "mauthausen", "birkenau", "concentration", "sieg_heil",
 "mussolini", "blackshirts", "fascist", "fascismo", "duce", "blackshirt",
 "franco", "falange", "falangist", "caudillo", "salazar", "estado_novo",
 "mosley", "moseley", "blackshirts", "british_union", "oswald_mosley",

 // Modern Neo-Nazi & White Supremacist
 "skinhead", "whitepride", "wpww", "rahowa", "white_race", "14words",
 "fourteen_words", "88", "hh", "1488", "wpww", "white_genocide",
 "whitegenocide", "white_lives", "altright", "alt_right", "groyper",
 "identitarian", "qanon", "wwg1wga", "redpill", "redpilled", "based",
 "whitey", "whitepower", "racial", "racepilled", "race_war", "racewar",
 "proud_boy", "proud_boys", "patriot_front", "atomwaffen", "siege",
 "accelerate", "boogaloo", "boojahadeen", "white_nationalist",
 "ethnostate", "white_ethnostate", "european_pride", "euronationalist",

 // Communist/Socialist Dictators & Terms
 "stalin", "stalinism", "stalinist", "gulag", "lenin", "leninism",
 "marx", "marxism", "marxist", "communism", "communist", "bolshevik",
 "mao", "maozedong", "mao_tse_tung", "cultural_revolution", "pol_pot",
 "khmer_rouge", "killing_fields", "kim_jong", "kim_il_sung", "juche",
 "castro", "che", "che_guevara", "trotsky", "tito", "ceausescu",
 "honecker", "holodomor", "nkvd", "kgb", "stasi", "securitate",
 "cheka", "red_army", "soviet", "ussr", "cccp", "kpss", "kpu",

 // Islamic Extremist & Terrorist
 "isis", "isil", "daesh", "islamic_state", "alqaeda", "al_qaeda",
 "taliban", "talib", "mujahideen", "jihad", "jihadi", "shahead",
 "caliphate", "khalifah", "binladen", "bin_laden", "osama", "zawahiri",
 "abu_bakr", "baghdadi", "hamza", "zarqawi", "boko_haram", "alshabab",
 "al_shabab", "hezbollah", "hamas", "irgc", "quds_force", "muhammad_atta",
 "jihadi_john", "anwar_awlaki", "mullah_omar", "abu_sayyaf",

 // Other Terrorist Groups & Terms
 "ira", "pira", "rira", "cira", "inla", "ulster", "uvf", "uda", "uff",
 "loyalist", "provo", "provisional", "continuity_ira", "real_ira",
 "eta", "basque", "tamil_tigers", "ltte", "pkk", "kurdistan",
 "shining_path", "sendero", "farc", "baader", "meinhof", "red_army_faction",
 "red_brigades", "weather_underground", "weathermen",

 // Additional Hate Groups & Terms
 "kkk", "klan", "klans", "klansman", "knight_rider", "grand_wizard",
 "imperial_wizard", "cyclops", "nighthawk", "cross_burning",
 "burning_cross", "white_knights", "united_klans", "invisible_empire",
 "aryan_brotherhood", "aryan_nation", "creativity_movement",
 "christian_identity", "phineas", "white_aryan", "hammerskin",
 "blood_and_honour", "combat18", "c18", "national_alliance",
 "national_socialist", "national_front", "american_front",

 // Anti-Semitic Terms
 "kike", "k1ke", "heeb", "hymie", "sheeny", "zhyd", "jude", "yid",
 "protocols", "zog", "zionist", "jewish_question", "jq", "goyim",
 "shekel", "holocaust_hoax", "holohoax", "six_million", "gas_chamber",
 "jew_lies", "jewish_lies", "jew_media", "jewish_media", "jew_world",
 "jewish_world", "synagogue", "talmud", "kehilla", "kahal",

 // Additional Racial/Ethnic Slurs (International)
 "chink", "gook", "jap", "nip", "zipperhead", "slope", "slant",
 "coolie", "chinky", "yellow_peril", "slant_eye", "slanteye",
 "curry_muncher", "sand_nigger", "sandnigger", "towelhead", "raghead",
 "camel_jockey", "dune_coon", "kebab", "paki", "hadji", "muzzie",
 "wetback", "spic", "beaner", "greaser", "greaseball", "taco", "tacohead",
 "spick", "spik", "chilango", "frijolero", "sudaca", "kaffir", "kaffer",
 "coon", "sambo", "jigaboo", "porch_monkey", "jungle_bunny", "spade",
 "goldberg", "macaca", "sooty", "darkie", "pickaninny", "pavement_ape",
 "mick", "paddy", "fenian", "taig", "bog_trotter", "potato_nigger",
 "kraut", "jerry", "fritz", "hun", "boche", "square_head", "teuton",
 "polack", "polock", "pollack", "russki", "ivan", "slav", "slavic",
 "wog", "dago", "guido", "guinea", "wop", "eyetie", "goombah",

 // Homophobic/Transphobic Slurs
 "faggot", "fag", "dyke", "tranny", "shemale", "ladyboy", "trap",
 "transvestite", "trannie", "fairy", "sissy", "queer", "homo",
 "sodomite", "poof", "poofter", "batty_boy", "bumboy", "pillow_biter",
 "shirt_lifter", "bender", "pansy", "fruit", "fruity", "nancy",
 "nance", "mary", "queens", "queenie", "queen", "flamer", "backdoor",
 "butt_pirate", "fudge_packer", "ass_bandit", "bum_boy", "puff",

 // Additional Sexual/Adult Terms
 "cuntface", "cuntfuck", "cunty", "cuntlick", "ballbag", "ball_bag",
 "ballsack", "ball_sack", "scrotum", "nutsack", "nut_sack", "nuts",
 "dickhead", "dickface", "dicklick", "dick_cheese", "smegma",
 "cocksucker", "cock", "deepthroat", "deep_throat", "throat_goat",
 "titties", "tittyfuck", "titsucker", "titlicker", "tit_fuck",
 "pussylick", "pussyeater", "pussy_eater", "cumslut", "cum_slut",
 "cumdump", "cum_dump", "cumguzzler", "cum_guzzler", "bukkake",
 "gangbang", "gang_bang", "rape", "rapist", "molester", "molest",
 "buttfuck", "butt_fuck", "buttplug", "butt_plug", "anal", "anus",
 "rimjob", "rim_job", "ass_to_mouth", "atm", "blowjob", "blow_job",
 "handjob", "hand_job", "wanker", "tosser", "jackoff", "jack_off",
 "jizz", "jizzy", "sperm", "cumshot", "cum_shot", "facial", "fisting",
 "fist", "bdsm", "bondage", "slave", "sex_slave", "master", "domination",
 "submissive", "dominant", "dominatrix", "daddy", "mommy", "pedophile",
 "pedo", "paedo", "nambla", "lolita", "loli", "shota", "jailbait",
 "barely_legal", "creep", "creeper", "groomer", "grooming",

 // Graphic Violence/Gore
 "gore", "guro", "snuff", "beheading", "behead", "necro", "necrophilia",
 "necrophile", "corpse", "cadaver", "torture", "mutilation", "mutilate",
 "dismember", "disembowel", "blood", "bloody", "bleeding", "guts",
 "entrails", "vivisection", "cannibalism", "cannibal", "flesh_eating",

 // Drug References
 "cocaine", "coke", "crack", "heroin", "smack", "horse", "dope",
 "meth", "crystal", "ice", "speed", "amphetamine", "mdma", "ecstasy",
 "molly", "acid", "lsd", "shrooms", "mushrooms", "weed", "marijuana",
 "cannabis", "pot", "hash", "hashish", "opium", "morphine", "junkie",
 "needle", "syringe", "dealer", "drug_dealer", "cartel", "narco",
 "narcos", "pablo", "escobar", "el_chapo", "sinaloa",

 // Additional Bad Words & Phrases
 "motherfucker", "motherfucking", "muthafucka", "mofo", "fucker",
 "fucking", "fucked", "fuckface", "fuckhead", "fuckwit", "fucktard",
 "clusterfuck", "dumbfuck", "bumblefuck", "dipshit", "douchebag",
 "douche", "bastard", "retard", "tard", "libtard", "cuntrag",
 "thundercunt", "shithead", "shit_head", "shitface", "shit_face",
 "shitbag", "shit_bag", "asshat", "asshole", "ass_hole", "arsehole",
 "twat", "twatwaffle", "minge", "prick", "knob", "bellend", "tosser",
 "wanker", "skank", "slag", "slut", "whore", "hoe", "thot", "bitch",
 "bitches", "son_of_a_bitch", "sob", "stfu", "fu", "foad", "gtfo",
 "lmfao", "omfg", "fml", "kys", "dildo", "vibrator", "fleshlight",

 // Extreme Political/Social Views
 "incel", "blackpill", "redpill", "bluepill", "mgtow", "mens_rights",
 "feminazi", "femoid", "roastie", "chad", "stacy", "becky", "tyrone",
 "soyboy", "cuck", "cuckold", "beta", "alpha", "sigma", "normie",
 "wagecuck", "wagie", "neet", "doomer", "coomer", "zoomer", "boomer",
 "karen", "simp", "white_knight", "sjw", "snowflake", "triggered",
 "libtard", "conservatard", "trumptard", "magat", "demoncrat",
 "demonrat", "libcuck", "republicuck", "democrap", "republicant",
 "rightoid", "leftoid", "leftist", "rightist", "antifa", "marxist",
 
 // Crime/Violence Related
 "killer", "murder", "murderer", "assassin", "hitman", "hit_man",
 "serial_killer", "mass_murderer", "school_shooter", "shooter",
 "gunman", "sniper", "massacre", "shooting", "columbine", "sandy_hook",
 "virginia_tech", "parkland", "pulse", "las_vegas", "el_paso",
 "christchurch", "anders_breivik", "brenton_tarrant", "timothy_mcveigh",
 "unabomber", "ted_kaczynski", "zodiac", "jack_ripper", "dahmer",
 "bundy", "gacy", "manson", "gang", "gangster", "mafia", "yakuza",
 "triads", "blood", "crip", "ms13", "cartel", "sicario", "thug",
 "thuglife", "criminal", "prison", "jail", "convict", "inmate",

 // Self-Harm/Suicide Related
 "suicide", "suicidal", "kill_myself", "kms", "cut", "cutter",
 "cutting", "self_harm", "depression", "depressed", "anorexia",
 "bulimia", "eating_disorder", "ed", "proana", "promia", "thinspo",
 "bonespo", "suicide_fuel", "rope", "an_hero", "end_it_all",

 // Animal Abuse/Cruelty
 "animal_abuse", "animal_killer", "cat_killer", "dog_killer",
 "puppy_killer", "kitten_killer", "animal_torture", "animal_rapist",
 "bestiality", "zoophile", "zoophilia", "yiff",

 // Additional Offensive Combinations
 "fuckboy", "fuccboi", "fuckboi", "fucktoy", "cumdumpster",
 "cockmongler", "cockmuncher", "dickmonger", "twatwaffle",
 "pussyslayer", "titmonster", "cumgoblin", "spermburper",
 "nutsniffer", "ballchinian", "dickbreath", "throatgoat",
 "meatbeater", "cocksmoker", "dickweed", "penisbreath",
 "vaginaface", "pussyface", "tittysucker", "assmuncher",
 "shiteater", "poopface", "pisshead", "pissdrinker",
 "shitstain", "asswipe", "dickcheese", "smegmaman",
 
 // Modern Internet Slang Offensive Terms
 "shitpost", "arse", "arsehole", "shitposter", "edgelord", "edgy", "triggered",
 "autist", "autism", "sperg", "sperglord", "downie", "mong",
 "mongoloid", "smoothbrain", "smooth_brain", "brainlet", "npc",
 "normie", "normalfag", "newfag", "oldfag", "betafag", "alphafag",
 "gayfag", "straightfag", "christfag", "muslimfag", "jewfag",
 "weeb", "weeaboo", "weebshit", "otaku", "neet", "tendies",
 "goodboy", "chad", "stacy", "tyrone", "jamal", "ricardo",

 // Website/Company Impersonation
 "facebook_admin", "fb_admin", "twitter_staff", "instagram_mod",
 "youtube_admin", "google_staff", "microsoft_support", "apple_care",
 "amazon_support", "netflix_admin", "spotify_staff", "discord_mod",
 "reddit_admin", "twitch_staff", "steam_admin", "valve_employee",
 "epic_games", "roblox_admin", "minecraft_staff", "mojang_admin",
 "nintendo_support", "sony_support", "xbox_support", "playstation",
 "admin", "linkist", "linkist_admin", "linkistadmin",
 
 // Financial/Scam Related
 "bitcoin_miner", "crypto_millionaire", "nft_trader", "wallstreet",
 "stock_trader", "forex_trader", "money_maker", "get_rich",
 "millionaire", "billionaire", "money_team", "cash_king",
 "wealth_guru", "finance_expert", "trading_pro", "investment_guru",
 "scammer", "scam", "phisher", "hacker", "hack", "ddos", "botnet",
 "malware", "ransomware", "virus_maker", "trojan", "keylogger",
 "password_stealer", "account_stealer", "credit_card", "bank_info",
 "social_security", "identity_theft", "fraudster", "ponzi",
 "pyramid_scheme", "mlm", "cash_app", "venmo", "paypal",

 // Additional System/Admin Variations
 "system32", "sys_admin", "network_admin", "database_admin",
 "server_admin", "cloud_admin", "security_admin", "it_admin",
 "web_admin", "site_admin", "forum_admin", "chat_admin",
 "game_admin", "server_op", "super_op", "head_admin",
 "chief_admin", "lead_admin", "senior_admin", "junior_admin",
 "admin_team", "mod_team", "support_team", "help_desk",
 "tech_support", "customer_support", "account_support", "accounts", "account",
 
 // Additional Variations in other languages
 "putain", "merde", "connard", "salope", "batard", "encule",
 "scheiße", "arschloch", "schwuchtel", "fotze", "hure", "schlampe",
 "puta", "maricon", "pendejo", "cabron", "chinga", "verga",
 "cazzo", "stronzo", "puttana", "merda", "troia", "vaffanculo",
 "kurwa", "chuj", "spierdalaj", "pierdol", "suka", "blyat",
 "pizda", "huilo", "mudak", "debil", "hohol", "katsap",

 // Generic Trolling/Harassment Terms
 "troll", "trolling", "griefer", "griefing", "spammer", "spam",
 "harassment", "harasser", "bully", "cyberbully", "toxic",
 "toxic_player", "rager", "rage_quit", "salt", "salty",
 "mad_cuz_bad", "git_gud", "get_good", "noob", "newb", "nub",
 "scrub", "casual", "tryhard", "sweat", "hater", "flamer",
 "keyboard_warrior", "internet_tough_guy", "basement_dweller"
];

// Generate all variations and combine with base list
const illegalUsernames = [...new Set([
  ...baseIllegalUsernames,
  ...baseIllegalUsernames.flatMap(word => generateVariations(word.toLowerCase()))
])];

export default illegalUsernames;